export default __webpack_public_path__ + "static/B0065-508e19364dcc63206514e6ba4aa4422c.png";